import React, { forwardRef } from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import FormError from 'forms/fields/FormError';

import './index.sass';
import { ticketFormat } from 'utils/dayjs';
import { Skeleton } from '@mui/material';

const { cnBlock, el } = bem('ticket-datetime-input');

const TicketDateTimeInput = ({ className, value = '', error, onClick, number, ...rest }) => {
    const inputValue = value ? ticketFormat(value) : '';

    const isValueSelected = inputValue !== '';

    return (
        <div className={ el('container', { 'active': isValueSelected }) } onClick={ onClick }>
            <div className={ el('number') }><Text serif>#{ number }</Text></div>
            { !isValueSelected &&
                <div className={ el('placeholder') }><Text tag={ 'div' }>Выберите дату и время</Text></div> }
            { isValueSelected && <input { ...rest } className={ cnBlock(className) } value={ inputValue } disabled/> }
            { error && <FormError/> }
        </div>
    );
};

export const TicketDateTimeInputSkeleton = () => {
    return (
        <div className={ el('container') } >
            <div className={ el('number') }><Text serif><Skeleton width={25} /></Text></div>
            <div className={ el('placeholder') }><Text tag={ 'div' }><Skeleton width={95} /></Text></div>
        </div>
    )
}

export default TicketDateTimeInput;
